import { allowedRedirectPaths } from 'data/allowed-redirect-path'
import { useAppSelector } from 'store'
import { encodeStringInBase64AndUri, generateRandomString } from 'utils/common'
import i18n from 'utils/i18n'
export const useIam = () => {
  const clientId = `${process.env.REACT_APP_CLIENT_ID}`
  const redirectUri = `${window.location.protocol}//${window.location.host}${process.env.REACT_APP_SIGN_IN_REDIRECT_PATH}`

  const temporaryId = useAppSelector((state) => state.iam.temporaryId)

  const generateState = (redirectPath?: string) => {
    const state = generateRandomString(10)
    if (redirectPath && allowedRedirectPaths.includes(redirectPath)) {
      return state + '_' + encodeStringInBase64AndUri(redirectPath)
    }
    return state
  }

  const handleSignIn = (account?: string, redirectPath?: string) => {
    window.samsungaccount.signInRedirect({
      clientId: clientId,
      redirectUri: redirectUri,
      responseType: 'code',
      scopes: ['profile'],
      state: generateState(redirectPath),
      locale: i18n.language,
      temporaryId: temporaryId,
      ...(typeof account === 'string' && account && { signInHint: account })
    })
  }

  const handleSignUp = (redirectPath?: string) => {
    window.samsungaccount.signUpRedirect({
      clientId,
      redirectUri,
      responseType: 'code',
      scopes: ['profile'],
      locale: i18n.language,
      temporaryId: temporaryId,
      state: generateState(redirectPath)
    })
  }

  return { handleSignIn, handleSignUp }
}
